<template>
  <div class="wrapper">
    <h1 style="text-align:center">{{ eventInfo.eventName }}报名</h1>

    <a-steps :current="step" type="navigation">
      <a-step
        title="信息填写"
      />
      <a-step
        title="信息确认"
      />
      <a-step
        title="报名成功"
      />
    </a-steps>
    <a-divider></a-divider>
    <div v-show="step==0 || step==1">
    <a-form :form="form" :label-col="_isMobile() ? {} : { span: 8 }" :wrapper-col="_isMobile() ? {} : { span: 12 }"
      :layout="_isMobile() ? 'vertical' : 'horizontal'">
      <a-row justify="center" type="flex">
        <a-col :xs="24" :sm="20" v-if="applyConfig.agentCode>0">
          <a-form-item label="识别码">
            <a-input :disabled="step==1" v-decorator="['agentCode', validatorRules.agentCode]"></a-input>
            <span>若无识别码，请联系老师或</span>
            <a-button type="link" @click="$refs.agentCodeSearch.eventId=eventId;$refs.agentCodeSearch.visible=true">点击自助查询</a-button>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="20">
          <a-form-item label="选择项目">
            <j-category-select v-decorator="['eventCategory', validatorRules.eventCategory]"
              :dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              :mutex="true" :onlyLeaf="true" :multiple="false" :treeCheckable="false"
              :pid="eventInfo.eventCategory" :categoryLimit="categoryLimit" categoryLimitStyle="hide" hideNoneChildrenNode
              @change="onEventCategoryChange"
              :disabled="step==1"
              placeholder="请选择项目" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="20" v-if="applyConfig.school>0">
          <a-form-item label="学校/机构">
           <a-input :readOnly="step==1" v-decorator="['school', validatorRules.school]"></a-input>
            <!-- <j-search-select-tag
                :disabled="model.activationCode || step==1"
                ref="searchTag"
                v-if="schoolType==1"
                placeholder="请选择学校/机构"
                :async="true"
                v-decorator="['school', validatorRules.school]"
                dict="teaching_agent,agent_name,agent_name,has_child=0">
              </j-search-select-tag>
            <a-input :readOnly="model.activationCode || step==1" v-if="schoolType==2" v-decorator="['school', validatorRules.school]"></a-input>
            <a-radio-group :disabled="model.activationCode || step==1" default-value="1" button-style="solid" v-model="schoolType" @change="schoolSelected">
              <a-radio-button :value="1">搜索</a-radio-button>
              <a-radio-button :value="2">手动输入</a-radio-button>
            </a-radio-group> -->
          </a-form-item>
        </a-col>
        
        <a-col :xs="24" :sm="20">
          <a-form-item label="姓名">
            <a-input :disabled="step==1" v-decorator="['realname', validatorRules.realname]"></a-input>
          </a-form-item>
        </a-col>

        <a-col :xs="24" :sm="20" v-if="applyConfig.idcard>0">
          <a-form-item label="证件号码">
            <a-input :disabled="step==1" v-decorator="['idcard', validatorRules.idcard[idcardType]]" placeholder="身份证/护照/台胞证"></a-input>
            <a-radio-group :disabled="step==1" default-value="1" button-style="solid" v-model="idcardType" @change="schoolSelected">
              <a-radio-button :value="1">身份证</a-radio-button>
              <a-radio-button :value="2">护照</a-radio-button>
              <a-radio-button :value="3">其他</a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>

        <!-- <a-col :xs="24" :sm="20">
          <a-form-item label="出生年月">
            <a-date-picker style="width: 100%" placeholder="请选择生日" v-decorator="[
              'birthday',
              validatorRules.birthday,
              { initialValue: null },
            ]" :getCalendarContainer="(node) => node.parentNode" />
          </a-form-item>
        </a-col> -->

        <a-col :xs="24" :sm="20" v-if="applyConfig.sex>0">
          <a-form-item label="性别">
            <a-radio-group :disabled="step==1" v-decorator="['sex', validatorRules.sex]">
              <a-radio-button :value="1"> 男 </a-radio-button>
              <a-radio-button :value="2"> 女 </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="20" v-if="applyConfig.photo>0">
          <a-form-item label="证件照"
            :required="applyConfig.photo==2">
            <a-tag color="orange">一寸蓝底免冠照，jpg或png格式，文件大小100KB以上5MB以内</a-tag>
            <a-row>
              <a-col :xs="24" :md="12">
                <div class="ant-upload-preview" @click="showPhotoModal">
                  <a-icon type="cloud-upload-o" class="upload-icon" />
                  <div class="mask">
                    <a-icon type="plus" />
                  </div>
                  <img v-if="userInfo" :src="userInfo.photo_url" />
                </div>
              </a-col>
              <a-col :xs="24" :md="12" class="photo-example">
                
                <img
                  width="180"
                  height="252"
                  src="@assets/photo-example.jpg"
                  alt="示例照片"
                />
                <h2 class="tips">示例照片</h2>
              </a-col>
            </a-row>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="20" v-if="applyConfig.grade>0">
          <a-form-item label="年级">
            <j-dict-select-tag :disabled="step==1" v-decorator="['grade', validatorRules.grade]" :trigger-change="true" dictCode="grade"
              placeholder="请选择年级" />
          </a-form-item>
        </a-col>

        <a-col :xs="24" :sm="20" v-if="applyConfig.email>0">
          <a-form-item label="邮箱">
            <a-input :disabled="step==1" v-decorator="['email', validatorRules.email]"></a-input>
          </a-form-item>
        </a-col>
        
        <a-col :xs="24" :sm="20" v-if="applyConfig.teacherName>0">
          <a-form-item label="辅导老师">
            <a-input :disabled="step==1" v-decorator="['teacherName', validatorRules.teacherName]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="20" v-if="applyConfig.teacherPhone>0">
          <a-form-item label="老师电话">
            <a-input :disabled="step==1" v-decorator="['teacherPhone', validatorRules.teacherPhone]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="20" v-if="applyConfig.parentName>0">
          <a-form-item label="监护人">
            <a-input :disabled="step==1" v-decorator="['parentName', validatorRules.parentName]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="20" v-if="applyConfig.parentPhone>0">
          <a-form-item label="监护人电话">
            <a-input v-decorator="['parentPhone', validatorRules.parentPhone]"></a-input>
          </a-form-item>
        </a-col>

        <a-col :xs="24" :sm="20" v-if="applyConfig.address>0" :style="_isMobile()?{height:'180px'}:{}">
          <a-form-item label="所处省市">
            <j-area-linkage :disabled="step==1" :type="_isMobile()?'select':'cascader'"  v-decorator="['address', validatorRules.address]" placeholder="请选择省市区" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="20" v-if="applyConfig.addressDetailed>0">
          <a-form-item label="寄送地址">
            <a-input v-decorator="['addressDetailed', validatorRules.addressDetailed]" placeholder="请填写详细地址"></a-input>
          </a-form-item>
        </a-col>

        <a-col :xs="24" :sm="20" v-if="applyConfig.activationCode>0">
          <a-form-item label="激活码">
            <a-switch :disabled="step==1 || applyConfig.activationCode==0" checked-children="使用" un-checked-children="不使用" v-model="useCode"></a-switch>
            <a-input  v-if="useCode" :disabled="step==1" v-decorator="['activationCode', validatorRules.activationCode]" placeholder="请填写激活码"></a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="15" v-if="eventInfo.applyTeam==1">
          <!-- 队友信息 -->
          <a-collapse defaultActiveKey="1">
            <a-collapse-panel key="1" header="队友信息 (如单人项目，不填)" forceRender>
              <a-form-item label="队友姓名">
                <a-input :disabled="step==1" v-decorator="['teammateNames']" placeholder=""></a-input>
              </a-form-item>
              <a-form-item label="证件号码">
                <a-input :disabled="step==1" v-decorator="['teammateIdcards']" placeholder=""></a-input>
              </a-form-item>
              <a-form-item label="年级">
                <j-dict-select-tag :disabled="step==1" v-decorator="['teammateGrades']" :trigger-change="true" dictCode="grade"
                  placeholder="请选择年级" />
              </a-form-item>
            </a-collapse-panel>
          </a-collapse>
        </a-col>

        <a-divider />
        <a-col :xs="24" :sm="20" v-if="model.eventCategory && step==1 && applyPrice>0">
          <a-alert message="参与测评项目确认" type="info" show-icon>
            <span slot="description">
              您选择了<span style="color:red">{{ model.eventCategory.split(',').length}}</span>个赛项，报名费用<span style="color:red">{{ applyPrice }}</span>元。
              <span v-if="model.activationCode">使用激活码进行全额抵扣。</span>
            </span>
          </a-alert>
        </a-col>
      </a-row>
    </a-form>
    </div>
    <div v-show="step==2">
      <h1 v-if="!eventInfo.eventApplyOk" style="text-align:center;">报名成功</h1>
      <div v-html="eventInfo.eventApplyOk"></div>
      <a-divider></a-divider>
      <h2 style="text-align:center;"><router-link target="_blank" :to="{ path: '/user/event', query: {}}">点击查看我报名的活动</router-link></h2>
    </div>
    <div class="btns">
      <a-button type="primary" class="btn" size="large" @click="reset" v-if="step==0">重填</a-button>
      <a-button type="primary" class="btn" size="large" @click="nextStep" v-if="step==0||step==2">下一步</a-button>
      <a-button type="primary" class="btn" size="large" @click="step=0;confirmLoading = false" v-if="step==1">上一步</a-button>
      <a-button type="primary" class="btn" size="large" v-if="step==1" :loading="confirmLoading" @click="handleOk">立即报名</a-button>
    </div>
    <EventPay ref="eventPay" @payOk="payOk" @cancel="confirmLoading = false"/>
    <EventAppleNoticeModal ref="applyNotice"/>
    <AgentCodeSearchModal ref="agentCodeSearch"/>
    <!-- <EventApplySuccessModal ref="applySuccess"/> -->
    <PhotoModal ref="photoModal" @ok="photoChange"></PhotoModal>
  </div>
</template>

<script>
import Vue from "vue";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import { mixinDevice } from '@/utils/mixin.js'
import { jumpMixins } from "@/utils/jumpMixins";
import moment from "moment";
import pick from "lodash.pick";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import JSearchSelectTag from '@/components/jeecg/JSearchSelectTag'
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import JCategorySelect from "@comp/jeecg/JCategorySelect";
import JUpload from '@/components/jeecg/JUpload'
import EventPay from "./modal/EventPay"
// import EventApplySuccessModal from "./modal/EventApplySuccessModal"
import EventAppleNoticeModal from "./modal/EventAppleNoticeModal"
import AgentCodeSearchModal from "./modal/AgentCodeSearchModal"
import PhotoModal from "@/components/user/PhotoModal";
import { filterMultiDictText } from "@comp/jeecg/JDictSelectUtil";
import { getQiniuUrl } from "@/utils/qiniu.js";

export default {
  name: "EventApply",
  mixins: [mixinDevice, jumpMixins],
  components: {
    JDictSelectTag,
    JAreaLinkage,
    JCategorySelect,
    JUpload,
    EventPay,
    // EventApplySuccessModal,
    EventAppleNoticeModal,
    PhotoModal,
    JSearchSelectTag,
    AgentCodeSearchModal
  },
  data() {
    return {
      visible: false,
      step: 0,
      confirmLoading: false,
      form: this.$form.createForm(this),
      model: {},
      eventId: "",
      eventInfo: {},
      userInfo: {},
      schoolType: 1,
      idcardType: 1, //1身份证 2护照 3其他
      applyPrice: 0, //报名费用
      applyEventInfo: {},
      categoryId: undefined,
      categoryLimit: null,
      school: undefined, //默认机构学校
      useCode: false, //使用激活码
      applyConfig: {
        photo: 1,
        idcard:2,
        sex:1,
        grade:1,
        email:1,
        teacherName:1,
        teacherPhone:1,
        parentName: 1,
        parentPhone:1,
        address: 1,
        school: 1
      },
      validatorRules: {
        agentCode: {
          rules: [
            { required: true, message: "请填写识别码!" },
            { validator: this.validateAgentCode }
          ],
        },
        activationCode:{
          rules: [
            { required: false, message: "请填写激活码" },
            { validator: this.validateCode }
          ],
        },
        photo: {
          rules: [{ required: true, message: "请上传证件照!" }],
        },
        realname: {
          rules: [{ required: true, message: "请输入真实姓名!" }],
        },
        idcard: {
          1:{
            rules: [
              {
                required: true,
                pattern:
                  /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
                message: "请输入正确的身份证号码!",
              },
            ],
          },
          2:{
            rules: [
              {
                required: true,
                pattern:
                  /^([a-zA-z]|[0-9]){5,17}$/,
                message: "请输入正确的护照号码!",
              },
            ],
          },
          3:{
            rules: [{ required: true, message: "请输入其他证件号码!" }],
          }
        },
        // birthday: {
        //   initialValue: '1999-10-10',
        //   rules: [
        //     { required: true, message: "请输入生日!" },
        //     { validator: this.handleBirthdayCheck },
        //   ],
        //   validateTrigger: ["change", "blur"],
        //   validateFirst: true,
        // },
        grade: {
          rules: [{ required: true, message: "请输入年级!" }],
        },
        schoolClass:{
          rules: [{ required: false, message: "请输入班级!" }],
        },
        email: {
          rules: [{
            required: true,
            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "请输入正确的邮箱地址!"
          }],
        },
        teacherName: {
          rules: [{ required: true, message: "请输入辅导老师姓名!" }],
        },
        teacherPhone: {
          rules: [
            {
              required: true,
              message: "请输入辅导老师手机号!",
              pattern: /^1[3456789]\d{9}$/,
            },
          ],
        },
        parentName: {
          rules: [{ required: false, message: "请输入监护人姓名!" }],
        },
        parentPhone: {
          rules: [
            {
              required: false,
              message: "请输入监护人手机号!",
              pattern: /^1[3456789]\d{9}$/,
            },
          ],
        },
        sex: {
          rules: [{ required: true, message: "请选择性别!" }],
        },
        school: {
          rules: [
            { required: true, message: "请填写学校/机构" },
          ],
        },
        address: {
          rules: [{ required: true, message: "请选择省市" }],
        },
        addressDetailed: {
          rules: [{ required: true, message: "请填写寄送详细地址" }],
        },
        eventCategory: {
          rules: [
            { required: true, message: "请选择报名类别" },
            { validator: this.validateCategory }
          ],
        },
      },
      scrollOptions: {
        behavior: 'smooth', // 滚动行为，可选值为auto、smooth
        block: 'center', // 竖直方向的对齐方式，可选值为start、center、end、nearest
        inline: 'nearest', // 水平方向的对齐方式，可选值为start、center、end、nearest
        offset: {
          top: 200, // 顶部偏移量
          left: 0, // 左侧偏移量
        },
        skipOverflowHiddenElements: true, // 是否忽略被overflow:hidden属性的元素，默认为false
      },
      shouldVerifyAgentCode: true
    };
  },
  created() {
    if (!Vue.ls.get(ACCESS_TOKEN)) {
        this.toLogin();
        return;
    }
    let that = this
    this.eventId = this.$route.query.id
    this.getEventInfo(this.eventId)
    this.getUserInfo();
    if(window.location.hash && window.location.hash.startsWith('#payok')){
      this.step=2
      let orderNo = window.location.hash.split("-")[1]
      this.$confirm({
        title: '是否支付成功?',
        content: '请在打开的页面进行付款，付款后，确认付款结果',
        onOk() {
          that.checkOrder(orderNo)
        },
        okText: "支付成功",
        onCancel() {
          that.checkOrder(orderNo)
          alert("请联系老师处理")
        },
        cancelText: "支付失败"
      });
    }
  },
  mounted(){
    this.school = this.$route.query.school
    if(this.school){
      this.$nextTick(() => {
        this.form.setFieldsValue({ school: this.school });
      });
    }
    this.categoryId = this.$route.query.cid
    if(this.categoryId){
      this.$nextTick(() => {
        this.form.setFieldsValue({ eventCategory: this.categoryId });
      });
    }
    
  },
  methods: {
    handleBirthdayCheck(rule, value, callback) {
      let birthday = this.form.getFieldValue("birthday");

      let idcard = this.form.getFieldValue("idcard");
      if (birthday === undefined) {
        callback(new Error("请选择生日"));
      }
      birthday = birthday.format("YYYYMMDD");
      console.log(birthday);
      if (value && !idcard.includes(birthday)) {
        callback(new Error("生日和身份证信息不一致"));
      }
      callback();
    },
    getEventInfo(eventId) {
      this.confirmLoading = true;
      getAction('/teaching/teachingEvent/queryById', { id: eventId }).then((res) => {
        if (res.success) {
          this.eventInfo = res.result
          if(this.step==0){
            this.$refs.applyNotice.show(this.eventInfo.eventApplyNotice)
          }
          // if(this.eventInfo.defaultSearchSchool && this.$refs.searchTag){
          //   this.$refs.searchTag.loadData(this.eventInfo.defaultSearchSchool)
          // }
          if(this.eventInfo.applyConfig){
            this.applyConfig = JSON.parse(this.eventInfo.applyConfig)
          }
          this.validatorRules.agentCode.rules[0].required = this.applyConfig.agentCode==2
          this.validatorRules.photo.rules[0].required = this.applyConfig.photo==2
          this.validatorRules.email.rules[0].required = this.applyConfig.email==2
          this.validatorRules.address.rules[0].required = this.applyConfig.address==2
          this.validatorRules.addressDetailed.rules[0].required = this.applyConfig.addressDetailed==2
          this.validatorRules.school.rules[0].required = this.applyConfig.school==2
          this.validatorRules.sex.rules[0].required = this.applyConfig.sex==2
          this.validatorRules.parentName.rules[0].required = this.applyConfig.parentName==2
          this.validatorRules.parentPhone.rules[0].required = this.applyConfig.parentPhone==2
          this.validatorRules.teacherName.rules[0].required = this.applyConfig.teacherName==2
          this.validatorRules.teacherPhone.rules[0].required = this.applyConfig.teacherPhone==2
          this.validatorRules.grade.rules[0].required = this.applyConfig.grade==2
          this.validatorRules.schoolClass.rules[0].required = this.applyConfig.schoolClass==2
          this.validatorRules.idcard[1].rules[0].required = this.applyConfig.idcard==2
          this.validatorRules.idcard[2].rules[0].required = this.applyConfig.idcard==2
          this.validatorRules.idcard[3].rules[0].required = this.applyConfig.idcard==2
          this.validatorRules.activationCode.rules[0].required = this.applyConfig.activationCode == 2
          this.useCode = this.applyConfig.activationCode == 2
          this.confirmLoading = false
        } else {
          this.$message.warning("活动不存在");
        }
      })
    },
    getUserInfo() {
      var that = this;
      getAction("/teaching/user/info").then((res) => {
        if (res.success) {
          that.userInfo = res.result;
          that.$nextTick(() => {
            that.form.setFieldsValue(
              pick(
                that.userInfo,
                "idcard",
                "sex",
                "realname",
                "email",
                "photo",
                "grade",
                "phone",
                "address",
                "addressDetailed",
                "school"
              )
            );
          });
        }
      });
    },
    validateCode(rule, value, callback){
      if(value){
        getAction("/teaching/teachingActivationCode/verifyCode?code="+value).then(res=>{
          if(res.success){
            let codeInfo = res.result
            // if(codeInfo.agentId){
            //   this.$nextTick(() => {
            //     this.form.setFieldsValue({ school: codeInfo.agentId});
            //   });
            // }
            this.model.activationCode = value
            callback()
          }else{
            this.model.activationCode = undefined
            // this.$nextTick(() => {
            //   this.form.setFieldsValue({ school: undefined});
            // });
            callback(res.message)
          }
        })
      }else{
        callback()
      }
    },
    validateAgentCode(rule, value, callback){
      if(!this.shouldVerifyAgentCode){
        callback()
        return
      }
      if(value){
        getAction("/teaching/teachingAgentCode/verifyCode",{
          code: value,
          eventId: this.eventInfo.id
        }).then(res=>{
          if(res.success){
            let codeInfo = res.result
            if(codeInfo.categoryId){
              this.categoryLimit = codeInfo.categoryId
              this.$nextTick(() => {
                this.form.setFieldsValue({ eventCategory: undefined});
                this.form.setFieldsValue({ school: codeInfo.agentId_dictText});
              });
            }
            this.model.agentCode = value
            callback()
          }else{
            this.model.agentCode = undefined
            callback(res.message)
          }
        })
      }else{
        // callback("请填写识别码!")
      }
    },
    validateCategory(rule, value, callback){
      let agentCode = this.form.getFieldValue("agentCode");
      if(value){
        getAction("/teaching/teachingEventApply/canApply",{
          eventId: this.eventId,
          categoryIds: value,
          agentCode: agentCode
        }).then(res=>{
          if(res.success){
            callback()
          }else{
            this.model.agentCode = undefined
            callback(res.message)
          }
        })
      }else{
        callback()
      }
    },
    //重填
    reset(){
      this.form.resetFields()
    },
    //选择了项目，计算费用
    onEventCategoryChange(value, label, data) {
      console.log( label);
      if(label.hasChild==1){
        return;
      }
      this.model.eventCategory = value
      getAction("/teaching/teachingEventCategory/getApplyPrice", {eventId:this.eventId, categoryIds:value}).then(res=>{
        if(res.success){
          this.applyPrice = res.result
        }
      })
      // for (let i in data) {
      //   if (data[i].customValue) {
      //     let config = JSON.parse(data[i].customValue)
      //     if (config.baseConfig && config.baseConfig.applyPrice) {
      //       console.log(label[i], config.baseConfig.applyPrice);
      //       let price = parseFloat(config.baseConfig.applyPrice)
      //       this.applyPrice += price
      //     }
      //   }
      // }
    },
    schoolSelected(){
      this.model.school = undefined
      this.form.setFieldsValue({ school: undefined });
    },
    showPhotoModal(){
      if(this.step == 0){
        this.$refs.photoModal.edit(1)
      }
    },
    photoChange(key, photoId) {
      console.log(key,photoId);
      this.form.setFieldsValue({photo: photoId})
      this.userInfo.photo = photoId
      Vue.set(this.userInfo, "photo", photoId)
      Vue.set(this.userInfo, "photo_url", getQiniuUrl(key))
    },
    nextStep(){
      let that = this;
      if(that.step==2){
        this.$router.push({ path: "/user/event" })
        return
      }
      if(that.applyConfig.photo==2 && !that.userInfo.photo_url){
        that.$message.error("请上传证件照");
        return
      }
      this.shouldVerifyAgentCode = false
      this.form.validateFieldsAndScroll({ scroll: this.scrollOptions },(err, values) => {
        console.log(err);
        if (!err) {
          that.step = 1
        }
        that.shouldVerifyAgentCode = true
      });
    },
    handleOk() {
      let that = this;
      if(that.applyConfig.photo==2 && !that.userInfo.photo){
        that.$message.error("请上传证件照");
        return
      }
      this.form.validateFieldsAndScroll((err, values) => {
        console.log(values);
        if (!err) {
          that.confirmLoading = true;
          if (!values.birthday) {
            values.birthday = "";
          } else {
            values.birthday = values.birthday.format("YYYY-MM-DD");
          }
          values.id = that.applyEventInfo.id
          values.eventId = that.eventId
          values.photo = that.userInfo.photo
          
          postAction("/teaching/teachingEventApply/apply", values).then((res) => {
            if (res.success) {
              if (that.applyPrice > 0 && !that.useCode) {
                //需要报名费且未使用激活码，则支付订单
                let orderInfo = res.result
                if (orderInfo) {
                  that.$refs.eventPay.open(orderInfo)
                } else {
                  that.step = 2
                }
              } else {
                that.step = 2
              }
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          })
        }else{
          that.step = 1
        }
      });
    },
    payOk() {
      this.step = 2
    },
    payError() {
      this.confirmLoading = false;
    },
    checkOrder(orderId){
      getAction("/teaching/teachingOrder/checkOrderCAC?outTradeNo="+orderId).then(res=>{
        if(res.success){
          this.$message.success('支付成功');
          this.$emit("payOk")
        }else{
          this.$message.error(res.message);
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  max-width: 1100px;
  margin: 50px auto;
  background: #ffffff;
  padding: 20px;
  box-shadow: #b48ef1 0 0 10px 3px;
}
.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 180px;
  height: 252px;
  box-shadow: 0 0 4px #ccc;
  .upload-icon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;
    &:hover {
      opacity: 1;
    }
    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }
  img,
  .mask {
    width: 180px;
    height: 252px;
    overflow: hidden;
  }
}
.photo-example {
  text-align: center;
  img {
  }
  .tips {
    position: relative;
    top: -200px;
    color: white;
    font-weight: 600;
    font-size: 30px;
    line-height: 0;
  }
}
.btns{
  text-align: center;
  margin:20px auto;
  .ant-btn{
    width:200px;
    display:inline-block;
    margin: 0 20px;
  }
}
</style>